// A page restored by Back/Forward (iOS Safari's back-forward cache, or a history
// load answered from the HTTP cache) keeps the cart drawer and header count frozen
// at the moment the page was left. Re-render the drawer the way the bundle's own
// CartDrawer.update() does, but from the drawer section only and bypassing the cache.
class CartRestoreSync extends HTMLElement {
  static DRAWER_SELECTOR = 'cart-drawer';

  static isHistoryNavigation() {
    const entry = performance.getEntriesByType?.('navigation')?.[0];
    return entry?.type === 'back_forward';
  }

  connectedCallback() {
    window.addEventListener('pageshow', this.onPageShow);
    if (CartRestoreSync.isHistoryNavigation()) this.refresh();
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onPageShow = (event) => {
    if (event.persisted) this.refresh();
  };

  async refresh() {
    const cartRequest = window.KarmaCart?.refresh().catch(() => null);

    await customElements.whenDefined(CartRestoreSync.DRAWER_SELECTOR);
    const drawer = document.querySelector(CartRestoreSync.DRAWER_SELECTOR);
    const sectionId = drawer?.dataset.sectionId;
    if (!sectionId || typeof drawer.getTemplateContent !== 'function') return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}?section_id=${encodeURIComponent(sectionId)}`, { cache: 'no-store' });
      if (!response.ok) return;

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = drawer.getTemplateContent(html);
      if (!node) return;

      const cart = await cartRequest;
      if (cart?.item_count > 0) drawer.updateAsideProductsByParsedState({ quantity: cart.item_count });

      drawer.lastDrawerBody = node;
      drawer.mount();
      drawer.emit('update-nodes', { node });
      drawer.updateEmptyStatus();
    } catch (error) {
      console.error(error);
    }
  }
}

if (!customElements.get('cart-restore-sync')) {
  customElements.define('cart-restore-sync', CartRestoreSync);
}
